export enum EbpCasePatientSupportLevel {
  One = 'Level 1',
  Two = 'Level 2',
  Three = 'Level 3',
}
